export default __webpack_public_path__ + "static/media/ic_alert.6aebe651.png";